import {ContentCardBaseComponent} from 'custom-extensions/ui-components/x-content-card-base';
import {html} from 'lit';
import {defineCustomElement} from 'custom-extensions/ui-utils';
import stylesheet from './x-category-card.scss?as=stylesheet';

export class CategoryCardComponent extends ContentCardBaseComponent {
	static get styles () {
		return [
			...super.styles,
			stylesheet
		];
	}

	static get properties () {
		return {};
	}

	constructor () {
		super();
	}

	renderImage () {
		return html`
			<div class="image">
				<x-image src="${this.imageUrl}" alt="${this.name} image" class="x-category-card-image"></x-image>
			</div>
		`;
	}

	renderInfo () {
		return html`
			<div class="info-container">
				<div class="name">${this.name}</div>
			</div>
		`;
	}
};

defineCustomElement('x-category-card', CategoryCardComponent);
